// extracted by mini-css-extract-plugin
var _1 = "InsightsRestriction-module__animatedBackground--LUlvH";
var _2 = "InsightsRestriction-module__container--N1WJx";
var _3 = "InsightsRestriction-module__note--_n9g_";
export { _1 as "animatedBackground", _2 as "container", _3 as "note" }
